import React, {
  useState,
} from 'react';

import './App.css';
import Gantt from './Gantt';

import { DateTime } from 'luxon';

import 'bootstrap/dist/css/bootstrap.min.css';

const now = DateTime.local();
const tasks = [
  {
    idx: 0,
    start: now,
    end: now.plus({ days: 2, hours: 12 }),
    progress: 75,
    deps: [ 4 ],
    reqs: [],
  },
  {
    idx: 1,
    start: now.plus({ days: 0 }),
    end: now.plus({ days: 18 }),
    progress: 25,
    deps: [],
    reqs: [],
    depEnforcement: 'ended',
  },
  {
    idx: 2,
    start: now.plus({ days: 6 }),
    end: now.plus({ days: 18 }),
    progress: 25,
    deps: [4],
    reqs: [],
    depEnforcement: 'begun',
  },
  {
    idx: 3,
    start: now.plus({ days: 14 }),
    end: now.plus({ days: 27, }),
    progress: 0,
    deps: [],
    reqs: [],
    links: [],
  },
  {
    idx: 4,
    start: now.plus({ days: 14 }),
    end: now.plus({ days: 21, }),
    progress: 0,
    deps: [],
    reqs: [],
  },
];

// If dependencies need cleaning
const homogeniseDeps = (interdeps) => {
  [...new Set(interdeps.deps)].sort();
  [...new Set(interdeps.reqs)].sort();
};

// If dependencies lack integrity
const verifyInterdeps = (interdeps) => {
  for (let interdep of interdeps) {
    const { idx, reqs, deps } = interdep;
    
    for (let dep of deps) {
      // The interdep with idx === dep should have req in its reqs
      const depReqs = interdeps.find(d => d.idx === dep).reqs;
      
      if (depReqs.indexOf(idx) === -1) return false;
    }
    
    for (let req of reqs) {
      // The interdep with idx === dep should have req in its reqs
      const reqDeps = interdeps.find(d => d.idx === req).deps;
      
      if (reqDeps.indexOf(idx) === -1) return false;
    }
  }
  
  return true;
};

const addDependency = (interdeps, idxFrom, idxTo) => {
  const { deps } = interdeps[idxFrom];
  const { reqs } = interdeps[idxTo];
  
  const depIdx = getSortedIdx(deps, idxTo);
  interdeps[idxFrom].deps = insertTo(deps, depIdx, idxTo);
  
  const reqIdx = getSortedIdx(interdeps[idxTo].deps, idxFrom);
  interdeps[idxTo].reqs = insertTo(reqs, reqIdx, idxFrom);
};
const getSortedIdx = (arr, val) => {
  let lo = 0;
  let hi = arr.length;

  while (lo < hi) {
    const mid = (lo + hi) >>> 1;
    
    if (arr[mid] < val) lo = mid + 1;
    else hi = mid;
  }
  return lo;
};
const insertTo = (arr, idx, item) => [
  ...arr.slice(0, idx), 
  item, 
  ...arr.slice(idx), 
];

const ganttBarMouseHandler = (e) => console.log(e);

export const GanttApp = (props) => {
  console.log('tasks', tasks);
  const [barData, setBarData] = useState(tasks);

  return (
    <Gantt
      barData={barData}
      setBarData={setBarData}
      onBarClick={ganttBarMouseHandler}
      onBarMove={ganttBarMouseHandler}
      {...props}
    />
  );
};
